export const PROFILE_BIRTH_DATE_LENGTH = 10;

export const PROFILE_BIRTH_DATE_FORMAT = /^(\d{2})\.(\d{2})\.(\d{4})$/;
